import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { Step3Props } from '../../../../../types/steps'
import ApartmentMediaForm from '../../../Forms/ApartmentMediaForm'

const Step3Media = ({
  apartment,
  currentStep,
  addApartmentMediaFiles,
  baseFormStepProps: { isMobile, doStepForward, doStepBack },
  deleteMedia,
  reorderMedia,
  doConfirmMedia,
  files,
  classes
}: Step3Props) => (
  <Fragment>
    {apartment?.information && currentStep === 11 && (
      <Grid container direction='row' justify='space-evenly'>
        <Grid item className={classes.form} xs={12}>
          <Paper style={{ width: '100%' }} className={classes.formPaper}>
            <ApartmentMediaForm
              isStep
              deleteMedia={deleteMedia}
              reorderMedia={reorderMedia}
              addApartmentMedia={addApartmentMediaFiles}
              files={files}
              media={apartment.media}
              isMobile={isMobile}
              classes={classes}
              currentStep={currentStep}
              confirmMedia={doConfirmMedia}
              doStepForward={doStepForward}
              doStepBack={doStepBack}
            />
          </Paper>
        </Grid>
      </Grid>
    )}
  </Fragment>
)

export default Step3Media
